var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.name)?_c('div',{attrs:{"id":"tag"}},[_c('a',{attrs:{"href":_vm.data.url}},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.data.name)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }